import html2canvas from 'html2canvas';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { pdf } from "@react-pdf/renderer";
import { useEffect, useRef, useState } from "react";
import channelFinanceService from "../../../services/channelFinance/channelFinance.service";
import invoiceService from "../services/invoice.service";
import "./../css/styles.css";



import {
    Document,
    Page,
    StyleSheet,
    Text,
    View,
    Font,
} from "@react-pdf/renderer";
import TaxInvoice from '../common/TaxInvoice';
import QRCode from "qrcode";
import { errorToast, successToast } from '../../../react-toastfiy/toast';
// import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";

export default function useCreateInvoice(active = {}) {

    const setShowModal = active.setShowModal
    const invoiceRef = useRef();
    const [step, setStep] = useState(1);
    const [downloadInvoiceData, setDownloadInvoiceData] = useState({ phone: "", type: "subscription", order_id: "" });



    const [customerData, setCustomerData] = useState({
        name: "",
        email: "",
        phone: "",
        gst: "",
        address: "",
        city: "",
        state: "",
        pincode: ""
    });

    const [billingData, setBillingData] = useState({
        invoiceNumber: "",
        invoiceDate: "",
        dueDate: "",
        description: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
        items: [],
        notes: ""
    });

    const [gstIncluded, setGstIncluded] = useState(true);
    const [pdfFile, setPdfFile] = useState(null);
    const handleCustomerChange = (e) => {
        setCustomerData({ ...customerData, [e.target.name]: e.target.value });
    };

    const handleBillingChange = (e) => {
        const { name, value } = e.target;

        const updatedData = {
            ...billingData,
            [name]: value,
        };

        const quantity = parseFloat(updatedData.quantity) || 0;
        const unit_price = parseFloat(updatedData.unit_price) || 0;
        updatedData.amount = quantity * unit_price;

        setBillingData(updatedData);
    };

    const handleItemChange = (e,) => {
        const { name, value } = e.target;
        const updatedItems = [...billingData.items];
        const index = billingData.items.length - 1;
        updatedItems[index][name] = name === "quantity" || name === "unit_price" ? parseFloat(value) || 0 : value;
        updatedItems[index].amount = updatedItems[index]?.quantity * updatedItems[index]?.unit_price;
        setBillingData({
            ...billingData,
            items: updatedItems,
        });
    };

    const addItem = () => {

        if (billingData?.description === "" || billingData?.quantity === 0 || billingData?.unit_price === 0) {
            errorToast("Please fill all the fields before adding a new item.");
            return;
        } else {

            const updateItems = {
                description: billingData?.description,
                quantity: billingData?.quantity,
                unit_price: billingData?.unit_price,
                amount: billingData?.amount,
            };

            setBillingData((prevData) => ({
                ...prevData, description: "",
                quantity: 1,
                unit_price: 0,
                amount: 0,
                items: [
                    ...prevData.items, updateItems]

            }))
        }
    };

    const subtotal = billingData.items.reduce((sum, item) => sum + Number(item.amount), 0);
    const gstunit_price = 18;
    const cgstunit_price = 9;
    const sgstunit_price = 9;

    const gstAmount = (subtotal * gstunit_price) / 100;
    const cgstAmount = (subtotal * cgstunit_price) / 100;
    const sgstAmount = (subtotal * sgstunit_price) / 100;

    let subtotalAmount = 0;

    if (!gstIncluded) {
        subtotalAmount = subtotal + gstAmount;
    } else {
        subtotalAmount = subtotal;
    }



    const downloadPdf = () => {
        const input = invoiceRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF("p", "mm", "a4");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save("invoice.pdf");

            setPdfFile(pdf.output('blob'));
        });
    };

    const handleRemoveItem = (index) => {

        setBillingData((prevData) => ({
            ...prevData,
            items: prevData.items.filter((_, i) => i !== index),
        }));
    }

    const handleUpdatebilling = (e, index) => {
        const { name, value } = e.target;
        const updatedItems = [...billingData.items];
        updatedItems[index][name] = name === "quantity" || name === "unit_price" ? parseFloat(value) || 0 : value;
        updatedItems[index].amount = updatedItems[index]?.quantity * updatedItems[index]?.unit_price;
        setBillingData({
            ...billingData,
            items: updatedItems,
        });
    };

    useEffect(() => {
        console.log(customerData?.phone, customerData?.phone.length);
        if (customerData?.phone.length === 10) {

            console.log("if", customerData?.phone, customerData?.phone.length);
            let userDetails = new FormData();
            userDetails.append("phone", customerData?.phone);
            channelFinanceService.GetUserExists(userDetails).then((res) => {
                if (res?.status === 200) {
                    setCustomerData((prevData) => ({
                        ...prevData,
                        name: `${res?.data?.first_name} ${res?.data?.middle_name} ${res?.data?.last_name}` || "",
                        email: res?.data?.email || "",
                        phone: res?.data?.phone || "",
                        gst: res?.data?.gst || "",
                        address: res?.data?.address || "",
                        city: res?.data?.city || "",
                        state: res?.data?.state || "",
                        pincode: res?.data?.pincode || ""

                    }))
                }
                console.log(res);
            });

            invoiceService.getInvoiceNo().then((res) => {
                if (res?.status === 200) {
                    setBillingData((prevData) => ({
                        ...prevData, invoiceNumber: res?.next_invoice_number
                    }))
                }
            })
        }


    }, [customerData?.phone]);

console.log({customerData, billingData});


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!invoiceRef.current) return;

        try {
            if (billingData?.invoiceDate === "" || billingData?.dueDate === "" || billingData?.items.length === 0) {
                errorToast("Please fill all the fields before submitting the invoice.");
                return;
            }
            let taxableAmount = (subtotalAmount / 1.18).toFixed(2);
            const qrCodeBase64 = await QRCode.toDataURL(
                `https://meratractor-invoices.s3.ap-south-1.amazonaws.com/${customerData?.phone}/general/${billingData?.invoiceNumber}.pdf`
            );



            const pdfBlob = await pdf(
                <TaxInvoice
                    formData={billingData}
                    data={customerData}
                    totalAmount={taxableAmount}
                    gstIncluded={gstIncluded}
                    subtotalAmount={subtotalAmount}
                    qrCodeBase64={qrCodeBase64}
                />
            ).toBlob();

            const url = URL.createObjectURL(pdfBlob);
            window.open(url);


            const formData = new FormData();
            formData.append("phone", customerData?.phone);
            formData.append("gst_number", customerData?.gst);
            formData.append("invoice_date", billingData?.invoiceDate);
            formData.append("due_date", billingData?.dueDate);
            formData.append("total_amount", subtotalAmount);
            if (customerData?.state === "Maharashtra") {
                formData.append("cgst", "9");
                formData.append("sgst", "9");
                formData.append("igst", 0);
            } else {
                formData.append("cgst", 0);
                formData.append("sgst", 0);
                formData.append("igst", "18");
            }

            formData.append("taxable_amount", taxableAmount);
            formData.append("tax_type", gstIncluded ? "inclusive" : "exclusive");
            formData.append("line_items", JSON.stringify(billingData?.items));
            formData.append("invoiceNumber", billingData?.invoiceNumber);
            formData.append("notes", "");
            formData.append("uid", downloadInvoiceData.order_id);


            const file = new File([pdfBlob], `${billingData?.invoiceNumber}.pdf`, { type: "application/pdf" });
            formData.append("invoice_pdf", file);


            const res = await invoiceService.CreateInvoice(formData);
            if (res?.status === 200) {
                console.log({res});
                successToast(res?.msg);
                setShowModal(false);

            } else {
                errorToast(res?.msg);
            }
            setStep(3);
        } catch (error) {
            console.error(error);
        }
    };


    const steps = ["Biller Details", "Item Details", "Invoice"]

    return {
        subtotal, subtotalAmount,
        invoiceRef, steps,
        step,
        setStep,
        customerData,
        setCustomerData,
        billingData,
        setBillingData,
        gstIncluded,
        setGstIncluded,
        pdfFile,
        setPdfFile,
        handleCustomerChange,
        handleBillingChange,
        handleItemChange,
        addItem,
        downloadPdf,
        handleRemoveItem,
        handleUpdatebilling,
        handleSubmit
    };
}